import { StyleRulesCallback, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = (theme: Theme) => ({
  root: {
    marginTop: theme.spacing.unit * 2,
    width: `calc(100% - ${theme.spacing.unit * 2}px)`
  }
});

type IProps = WithStyles<typeof styles>;

const ContainerBase: React.FC<IProps> = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
);

export const Container = withStyles(styles)(ContainerBase);
